import {connect} from 'react-redux';

import {TimespanCategory} from '@pluto/rest';
import {
    resetCategoryAction,
    ResetCategoryAction,
    setCategoryAction,
    SetCategoryAction,
    TimespanCategoriesState,
} from '@pluto/timespan-categories';

import {SetNotificationAction, setNotificationAction} from '@pluto/notification';
import {
    enableAudioTrackAction,
    disableAudioTrackAction,
    setAudioTrackAction,
    resetAudioTrackAction,
    resetAudioTracksAction,
    SetAudioTrack,
    EnableAudioTrack,
    DisableAudioTrack,
    ResetAudioTrack,
    ResetAudioTracks,
    disableAudioChannelAction,
    enableAudioChannelAction,
    EnableAudioChannel,
    DisableAudioChannel,
    SetAudioAvailableChannelOutput,
    setAudioAvailableChannelOutputAction,
} from './Timeline/AudioTracks/Redux/AudioTracksActions';
import VideoAudioQCContainer from './VideoAudioQCContainer';
import {
    createQCReportMarkerAction,
    updateQCReportMarkerAction,
    CreateQCReportMarkerAction,
    UpdateQCReportMarkerAction,
} from './Timeline/QCReport/Redux/QCReportActions';
import {
    CreateAdBreakMarkerAction,
    createAdBreakMarkerAction,
    updateAdBreaksMarkerAction,
    UpdateAdBreaksMarkerAction,
} from './Timeline/AdBreaks/Redux/AdBreaksActions';
import {
    createMarkupMarkerAction,
    CreateMarkupMarkerAction,
    updateMarkupMarkerAction,
    UpdateMarkupMarkerAction,
} from './Timeline/Markup/Redux/MarkupActions';

interface DispatchProps {
    setCategory: SetCategoryAction,
    resetCategory: ResetCategoryAction,
    setAudioTrack: SetAudioTrack;
    enableAudioTrack: EnableAudioTrack;
    disableAudioTrack: DisableAudioTrack;
    resetAudioTrack: ResetAudioTrack;
    resetAudioTracks: ResetAudioTracks;
    enableAudioChannel: EnableAudioChannel;
    disableAudioChannel: DisableAudioChannel;
    createAdBreakMarker: CreateAdBreakMarkerAction;
    createQCReportMarker: CreateQCReportMarkerAction;
    createMarkupMarker: CreateMarkupMarkerAction;
    updateQCReportMarker: UpdateQCReportMarkerAction;
    updateAdBreaksMarker: UpdateAdBreaksMarkerAction;
    updateMarkupMarker: UpdateMarkupMarkerAction;
    setNotification: SetNotificationAction;
    setAudioAvailableChannelOutput: SetAudioAvailableChannelOutput;
}

interface StateProps {
    // item: Item | null;
    markupIssueTypes: TimespanCategory[];
}

export type State = {
    contentItemView: {
        timespanCategories: TimespanCategoriesState,
    },
};

export const mapState = (state: State): StateProps => {
    const {timespanCategories} = state.contentItemView;
    const {markup} = timespanCategories;

    return {
        markupIssueTypes: markup,
    };
};

export const mapDispatch: DispatchProps = {
    setCategory: setCategoryAction,
    resetCategory: resetCategoryAction,
    setAudioTrack: setAudioTrackAction,
    enableAudioTrack: enableAudioTrackAction,
    disableAudioTrack: disableAudioTrackAction,
    resetAudioTrack: resetAudioTrackAction,
    resetAudioTracks: resetAudioTracksAction,
    enableAudioChannel: enableAudioChannelAction,
    disableAudioChannel: disableAudioChannelAction,
    createAdBreakMarker: createAdBreakMarkerAction as CreateAdBreakMarkerAction,
    createQCReportMarker: createQCReportMarkerAction as CreateQCReportMarkerAction,
    createMarkupMarker: createMarkupMarkerAction as CreateMarkupMarkerAction,
    updateQCReportMarker: updateQCReportMarkerAction as UpdateQCReportMarkerAction,
    updateAdBreaksMarker: updateAdBreaksMarkerAction as UpdateAdBreaksMarkerAction,
    updateMarkupMarker: updateMarkupMarkerAction as UpdateMarkupMarkerAction,
    setNotification: setNotificationAction,
    setAudioAvailableChannelOutput: setAudioAvailableChannelOutputAction,
};

export default connect(mapState, mapDispatch)(VideoAudioQCContainer);
